import { IPlaceOption } from 'types/IPlaceOption'

interface IHighlightResult {
  value: string
  matchLevel: string
  fullyHighlighted?: boolean
  matchedWords: string[]
}

export interface IAlgoliaHit {
  country: string
  is_country: boolean
  is_highway: boolean
  importance: number
  _tags: string[]
  postcode: string[]
  county: string[]
  population: number
  country_code: string
  is_city: boolean
  is_popular: boolean
  administrative: string[]
  admin_level: number
  is_suburb: boolean
  locale_names: string[]
  _geoloc: {
    lat: number
    lng: number
  }
  objectID: string
  _highlightResult: {
    country: IHighlightResult
    postcode: IHighlightResult[]
    county: IHighlightResult[]
    administrative: IHighlightResult[]
    locale_names: IHighlightResult[]
  }
}

export const algoliaPlacesInitialState = {
  searchTerm: '',
  options: [] as IPlaceOption[],
  isLoading: false,
  isSelectorOpen: false
}

export type AlgoliaPlacesState = typeof algoliaPlacesInitialState
